import { Col, Row } from 'antd';

import { useGetBasicUomEnum } from 'hooks';
import { getUomTypesAbbreviations } from '../constants';

import NutrientRowNew from '../NutrientRowNew';
import { SnapshotHighlightText } from '../WrapperNutrient';
import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import NutrientSideBySide from './NutrientSideBySide';
import { renderContainerDescriptor } from 'pages/product-full-view/components/product-media-area/multiple-panel/components/utils.js';

function VerticalLabelWithMicronutrient({
  property,
  nutrients,
  snapshotValue,
}) {
  const { basicUomProperties } = useGetBasicUomEnum();
  const servingPerContainerDescriptor = renderContainerDescriptor(
    property?.servingPerContainerDescriptor,
  );

  const getNutrientBasisQtyTypeCode = (label) => {
    if (label?.nutrientBasisQuantityTypeCode === 'By Child Nutrition serving') {
      return 'Child Nutrition serving';
    }
    if (label?.nutrientBasisQuantityTypeCode === 'By Package or Container') {
      return 'Container';
    }
    if (label?.nutrientBasisQuantityTypeCode === 'By Measure') {
      return 'Measure';
    }

    return 'Serving';
  };

  return (
    <div class='nutrition-facts scroller'>
      <h1 className='nutrition-facts__label'>Nutrition Facts</h1>
      <SeparatorBar />
      <div className='nutrition-facts__servingsize'>
        {Boolean(property?.numberOfServingsPerPackage) && (
          <SnapshotHighlightText
            label={['numberOfServingsPerPackage']}
            currentValue={property}
            snapshotValue={snapshotValue}
          >
            <div className='nutrition-facts__servings-per-container'>
              <p style={{ textTransform: 'capitalize', marginBottom: 0 }}>
                {servingPerContainerDescriptor ? (
                  <span>{servingPerContainerDescriptor}&nbsp;</span>
                ) : null}
                {property?.numberOfServingsPerPackage} servings per container
              </p>
            </div>
          </SnapshotHighlightText>
        )}
        <SnapshotHighlightText
          label={[
            'servingSizeDescription',
            'servingSize',
            'servingSizeMeasurement',
          ]}
          currentValue={property}
          snapshotValue={snapshotValue}
        >
          <div className='nutrition-facts__servingsize-bold'>
            <div>Serving size</div>
            <div class='nutrition-facts__servingsize-word-break'>
              {property?.servingSizeDescription}{' '}
              {property?.servingSize &&
                `(${property?.servingSize} ${getUomTypesAbbreviations(
                  basicUomProperties,
                  property?.servingSizeMeasurement,
                )})`}
            </div>
          </div>
        </SnapshotHighlightText>
      </div>
      <SeparatorBar height={7} />
      <SnapshotHighlightText
        label={['calories']}
        currentValue={property}
        snapshotValue={snapshotValue}
      >
        <div className='nutrition-facts__calories-container'>
          <div>
            <div className='nutrition-facts__calories'>
              Amount Per {getNutrientBasisQtyTypeCode(property)}
            </div>
            <div className='nutrition-facts__calories_new-calories'>
              Calories
            </div>
          </div>

          <div className='nutrition-facts__calories_numeric'>
            {property?.calories}
          </div>
        </div>
      </SnapshotHighlightText>
      <SeparatorBar height={3} />
      <div className='nutrition-facts__dv-heading'>% Daily Value*</div>
      <Row>
        {nutrients?.map((nutrient, index) => {
          const { isStepByStep } = nutrient;
          return (
            <Col span={isStepByStep ? 12 : 24} key={index}>
              {isStepByStep ? (
                <NutrientSideBySide
                  index={index}
                  showDot={index % 2 !== 0}
                  nutrient={nutrient}
                />
              ) : (
                <NutrientRowNew nutrient={nutrient} />
              )}
            </Col>
          );
        })}
      </Row>
      <SeparatorBar height={3} />
      <SnapshotHighlightText
        label={['fdaLabelFootNote']}
        currentValue={property}
        snapshotValue={snapshotValue}
      >
        <div className='nutrition-facts__footnote'>
          <span>*</span>
          {property?.fdaLabelFootNote}
        </div>
      </SnapshotHighlightText>
    </div>
  );
}

export default VerticalLabelWithMicronutrient;
